(() => {
  'use strict';
  if (window.marqueV55SizeControlsReady) return;
  window.marqueV55SizeControlsReady = true;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const active = event.target.closest('.marque-card__sizes');
    document.querySelectorAll('.marque-card__sizes[open]').forEach(details => {
      if (details !== active) details.open = false;
    });
  });
})();